import hogan from 'hogan.js';

export default {
  /**
   * Renders `template` string using `data` object
   * @param {String} template - template string. variables should be wrapped into {{}}
   * @param {Object} data - object with variables
   * @param {Object} [compilationOptions] - optional options for template compilation
   * @returns {String} - rendered template
   */
  renderString(template, data, compilationOptions = {}) {
    return hogan.compile(template, compilationOptions).render(data);
  }
};
